import { createSelector } from '@reduxjs/toolkit';

import type { RootState } from '../../store';

export const selectMembershipState = (state: RootState) => state.membership;

export const selectMemberships = createSelector(
  selectMembershipState,
  (state) => state.memberships.value
);

export const selectMembershipsLoading = createSelector(
  selectMembershipState,
  (state) => state.memberships.loading
);

export const selectMembershipsLoaded = createSelector(
  selectMembershipState,
  (state) => state.memberships.loaded
);

export const selectMembershipError = createSelector(
  selectMembershipState,
  (state) => state.memberships.error
);

export const selectMembershipView = createSelector(
  selectMembershipState,
  (state) => state.selectedView
);

export const selectSelectedMembership = createSelector(
  selectMembershipState,
  (state) => state.selectedMembership
);

export const selectMembershipUpdating = createSelector(
  selectMembershipState,
  (state) => state.updating.loading
);

export const selectMembershipCancelling = createSelector(
  selectMembershipState,
  (state) => state.cancelling.loading
);

export const selectAddressData = createSelector(
  selectMembershipState,
  (state) => state.addressData.value
);

export const selectAddressUpdating = createSelector(
  selectMembershipState,
  (state) => state.updatingAddress.loading
);

export const selectCreatingContract = createSelector(
  selectMembershipState,
  (state) => state.creatingContract.loading
);

export const selectCreatedContract = createSelector(
  selectMembershipState,
  (state) => state.creatingContract.loaded
);

export const selectAddingToCart = createSelector(
  selectMembershipState,
  (state) => state.addToCart.loading
);

export const selectAddedToCart = createSelector(
  selectMembershipState,
  (state) => state.addToCart.loaded
);

export const selectIsTierAddingToCart = (tierId: string) =>
  createSelector(
    selectAddingToCart,
    selectMembershipState, // if you have this
    (loading, state) => loading && state.addToCart.value === tierId
  );

export const selectMembershipJoinRequest = createSelector(
  selectMembershipState,
  (state) => state.membershipJoinRequest
);

export const selectJoinInProgress = createSelector(
  selectMembershipState,
  (state) => state.joinInProgress
);

export const selectReferralLink = createSelector(
  selectMembershipState,
  (state) => state.referralLink.value
);
